module.exports = __webpack_public_path__ + "img/mercedesbenz.cc3775b3.svg";